import { render } from "./centroDetailModal.vue?vue&type=template&id=2ae97258&scoped=true&ts=true"
import script from "./centroDetailModal.vue?vue&type=script&lang=ts"
export * from "./centroDetailModal.vue?vue&type=script&lang=ts"

import "./centroDetailModal.vue?vue&type=style&index=0&id=2ae97258&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae97258"]])

export default __exports__